var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.667 34.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #95989a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1526076_cc",
    transform: "translate(-3 -15.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3 15.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Compound_Path",
    "data-name": "Compound Path",
    className: "cls-1",
    d: "M21.2,15.8H9.44a1.014,1.014,0,0,0-1.014,1.014v9.939H7.919A1.014,1.014,0,0,0,6.9,27.766v5.477H4.014A1.014,1.014,0,0,0,3,34.257v9.229a3.043,3.043,0,0,0,3.043,3.043H7.665a4.919,4.919,0,0,0,9.635,0H36.316a4.919,4.919,0,0,0,9.635,0h1.673a3.043,3.043,0,0,0,3.043-3.043v-7.2a3.043,3.043,0,0,0-2.333-2.941L44.48,24.876a4.107,4.107,0,0,0-3.7-2.333H33.324a1.014,1.014,0,0,0-1.014,1.014v9.685H29.115v-10.6A1.014,1.014,0,0,0,28.1,21.63H22.219V16.813A.963.963,0,0,0,21.2,15.8Zm-10.75,2.028H20.19v3.8H16.134a.963.963,0,0,0-1.014,1.014v4.107H10.454ZM8.933,28.78h6.187v4.462H8.933Zm3.55,19.675a2.84,2.84,0,0,1-2.84-2.84,2.891,2.891,0,0,1,2.84-2.89,2.941,2.941,0,0,1,2.89,2.89,2.89,2.89,0,0,1-2.89,2.84Zm28.651,0a2.865,2.865,0,1,1,2.89-2.84A2.891,2.891,0,0,1,41.133,48.455Zm7.5-4.969A1.014,1.014,0,0,1,47.624,44.5H45.9a4.868,4.868,0,0,0-9.533,0H17.249a4.868,4.868,0,0,0-9.533,0H6.043a1.014,1.014,0,0,1-1.014-1.014V35.271h42.6a1.014,1.014,0,0,1,1.014,1.014Zm-14.3-18.914h6.44A2.028,2.028,0,0,1,42.6,25.738l3.448,7.5H34.338Zm-7.251,8.671H17.148V23.659h9.939Z",
    transform: "translate(-3 -15.797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.6fec54003579b6f091c23a6a73b6094f.svg";
export { ForwardRef as ReactComponent };